export default __webpack_public_path__ + "static/column-trainer-2-289269db8be7533ce329906d620ce516.jpg";